import React from 'react';
import { Link } from 'react-router-dom';
import Footer from './Footer';
import Header from './Header';

function Service() {

    

    return (
        <>
        
             <Header/>
            <section className="hero-section">
                <div className="container">
                    <div className="row align-items-center">
                        <div className="col-md-5">
                            <h2 className="text-white fw-normal mb-4 mt-3 lh-base">
                                Service
                            </h2>
                        </div>
                    </div>
                    {/* <div className="col-md-5 offset-md-2">
                            <div className="text-md-end mt-3 mt-md-0">
                                <img src="assets/images/svg/startup.svg" alt className="img-fluid" />
                            </div>
                        </div> */}
                </div>
            </section>
            <br />
            <section id="about" className="about section light-background">
                <div className="container section-title" data-aos="fade-up">
                    <div className="d-flex justify-content-center">
                        <button
                            type="button"
                            className="btn btn-light rounded-pill"
                        >
                            Service
                        </button>
                    </div>
                    <h1 style={{ textAlign: 'center' }}>
                        <span>Our</span> <span className="link-primary">Service</span>
                    </h1>
                </div>
            </section>

            <section className="py-5 bg-light-lighten border-top border-bottom border-light">
                <div className="container">
                    <div className="row">
                        <div className="col-12">
                            <div className="row g-4">

                                <div className="col-md-4">
                                    <Link to="/creditcardservice">
                                        <div
                                            className="card d-block"
                                            style={{
                                                boxShadow: "0 4px 10px rgba(0, 0, 0, 0.3)", // Shadow effect
                                                backgroundColor: "#5971da", // Dark background
                                                color: "#ffffff", // Text color for contrast
                                                transition: "box-shadow 0.3s ease-in-out",
                                            }}
                                        >
                                            <img
                                                className="card-img-top"
                                                src="assets/images/small/small-1.png"
                                                alt="Card image cap"
                                            />
                                            <div className="card-body">
                                                <h4 className="card-title"><b>Credit Card Service</b></h4>
                                                <p className="card-text justify-text">
                                                    <b>Sai Financial Service</b> offers a comprehensive range of credit card solutions to meet your financial needs.
                                                    We work with all major banks to provide you with the best credit card offers tailored to your spending habits and lifestyle.
                                                </p>
                                                <br />
                                                <div className="d-grid">
                                                    <Link to="/creditcardservice" type="button" class="btn btn-outline-dark">Apply</Link>
                                                </div>
                                            </div>
                                        </div>
                                    </Link>
                                </div>

                                <div className="col-md-4">
                                    <Link to="/loanservice">
                                        <div
                                            className="card d-block"
                                            style={{
                                                boxShadow: "0 4px 10px rgba(0, 0, 0, 0.3)", // Shadow effect
                                                backgroundColor: "#5971da", // Dark background
                                                color: "#ffffff", // Text color for contrast
                                                transition: "box-shadow 0.3s ease-in-out",
                                            }}
                                        >
                                            <img
                                                className="card-img-top"
                                                src="assets/images/small/small-2.png"
                                                alt="Card image cap"
                                            />
                                            <div className="card-body">
                                                <h4 className="card-title"><b>Loan Service</b></h4>
                                                <p className="card-text justify-text">
                                                    Whether you're looking to buy a new home, expand your business, or need personal financing, <b>Sai Financial Service</b> helps you secure loans from leading banks and financial institutions.
                                                    We offer personalized loan solutions with competitive interest rates and flexible repayment terms.
                                                </p>
                                                <div className="d-grid">
                                                    <Link to="/loanservice" type="button" class="btn btn-outline-dark">Apply</Link>
                                                </div>
                                            </div>
                                        </div>
                                    </Link>
                                </div>

                                <div className="col-md-4">
                                    <Link to="/insuranceservice">
                                        <div
                                            className="card d-block"
                                            style={{
                                                boxShadow: "0 4px 10px rgba(0, 0, 0, 0.3)", // Shadow effect
                                                backgroundColor: "#5971da", // Dark background
                                                color: "#ffffff", // Text color for contrast
                                                transition: "box-shadow 0.3s ease-in-out",
                                            }}
                                        >
                                            <img
                                                className="card-img-top"
                                                src="assets/images/small/small-3.jpg"
                                                alt="Card image cap"
                                            />
                                            <div className="card-body">
                                                <h4 className="card-title"><b>Insurance Service</b></h4>
                                                <p className="card-text justify-text">
                                                    <b>Sai Financial Service</b> provides insurance services to help secure your future and safeguard your assets.
                                                    We offer a range of insurance policies from reputed companies, including health, life, and vehicle insurance.
                                                </p>
                                                <br />
                                                <br />
                                                <div className="d-grid">
                                                    <Link to="/insuranceservice" type="button" class="btn btn-outline-dark">Apply</Link>
                                                </div>
                                            </div>
                                        </div>
                                    </Link>
                                </div>

                                <div className="col-md-4">
                                    <Link to="/creditcardswipeservice">
                                        <div
                                            className="card d-block"
                                            style={{
                                                boxShadow: "0 4px 10px rgba(0, 0, 0, 0.3)", // Shadow effect
                                                backgroundColor: "#5971da", // Dark background
                                                color: "#ffffff", // Text color for contrast
                                                transition: "box-shadow 0.3s ease-in-out",
                                            }}
                                        >
                                            <img
                                                className="card-img-top"
                                                src="assets/images/small/small-4.png"
                                                alt="Card image cap"
                                            />
                                            <div className="card-body">
                                                <h4 className="card-title"><b>Credit Card Swipe Services</b></h4>
                                                <p className="card-text">
                                                    we make credit card cash withdrawals simple, fast, and hassle-free. Whether you need emergency cash or want to maximize your credit card's features,
                                                    our services provide a secure and reliable solution to access funds anytime.
                                                </p>
                                                <br />
                                                <div className="d-grid">
                                                    <Link to="/creditcardswipeservice" type="button" class="btn btn-outline-dark">Apply</Link>
                                                </div>
                                            </div>
                                        </div>
                                    </Link>
                                </div>

                                <div className="col-md-4">
                                    <Link to="/passportservicesservice">
                                        <div
                                            className="card d-block"
                                            style={{
                                                boxShadow: "0 4px 10px rgba(0, 0, 0, 0.3)", // Shadow effect
                                                backgroundColor: "#5971da", // Dark background
                                                color: "#ffffff", // Text color for contrast
                                                transition: "box-shadow 0.3s ease-in-out",
                                            }}
                                        >
                                            <img
                                                className="card-img-top"
                                                src="assets/images/small/small-10.png"
                                                alt="Card image cap"
                                            />
                                            <div className="card-body">
                                                <h4 className="card-title"><b>Passport Services</b></h4>
                                                <p className="card-text">
                                                    we offer reliable and efficient online assistance for passport-related services.
                                                    Whether you're applying for a new passport, renewing an existing one, or updating your details, we simplify the process to save you time and effort..
                                                </p>
                                                <br />
                                                <div className="d-grid">
                                                    <Link to="/passportservicesservice" type="button" class="btn btn-outline-dark">Apply</Link>
                                                </div>

                                            </div>
                                        </div>
                                    </Link>
                                </div>

                                <div className="col-md-4">
                                    <Link to="/creditcardservice">
                                        <div
                                            className="card d-block"
                                            style={{
                                                boxShadow: "0 4px 10px rgba(0, 0, 0, 0.3)", // Shadow effect
                                                backgroundColor: "#5971da", // Dark background
                                                color: "#ffffff", // Text color for contrast
                                                transition: "box-shadow 0.3s ease-in-out",
                                            }}
                                        >
                                            <img
                                                className="card-img-top"
                                                src="assets/images/small/small-6.png"
                                                alt="Card image cap"
                                            />
                                            <div className="card-body">
                                                <h4 className="card-title"><b>Pan Card Services</b></h4>
                                                <p className="card-text">
                                                    we specialize in offering seamless, reliable, and secure online government card services, including PAN card issuance and related assistance.
                                                    Whether you're applying for a new PAN card, updating details, or reprinting a lost one, we ensure a hassle-free experience.
                                                </p>
                                                <div className="d-grid">
                                                    <Link to="" type="button" class="btn btn-outline-dark">Apply</Link>
                                                </div>

                                            </div>
                                        </div>
                                    </Link>
                                </div>

                                <div className="col-md-4">
                                    <Link to="/udhyamservice">
                                        <div
                                            className="card d-block"
                                            style={{
                                                boxShadow: "0 4px 10px rgba(0, 0, 0, 0.3)", // Shadow effect
                                                backgroundColor: "#5971da", // Dark background
                                                color: "#ffffff", // Text color for contrast
                                                transition: "box-shadow 0.3s ease-in-out",
                                            }}
                                        >
                                            <img
                                                className="card-img-top"
                                                src="assets/images/small/small-7.png"
                                                alt="Card image cap"
                                            />
                                            <div className="card-body">
                                                <h4 className="card-title"><b>Udhyam Services</b></h4>
                                                <p className="card-text">
                                                    we specialize in providing comprehensive online assistance for Udyam Registration and other government card services.
                                                    Designed for entrepreneurs and small businesses, our services streamline the process, enabling you to take advantage of the benefits offered under the Micro, Small, and Medium Enterprises (MSME) Development Act.
                                                </p>
                                                <div className="d-grid">
                                                    <Link to="/udhyamservice" type="button" class="btn btn-outline-dark">Apply</Link>
                                                </div>
                                            </div>
                                        </div>
                                    </Link>
                                </div>

                                <div className="col-md-4">
                                    <Link to="/voterIDcardservice">
                                        <div
                                            className="card d-block"
                                            style={{
                                                boxShadow: "0 4px 10px rgba(0, 0, 0, 0.3)", // Shadow effect
                                                backgroundColor: "#5971da", // Dark background
                                                color: "#ffffff", // Text color for contrast
                                                transition: "box-shadow 0.3s ease-in-out",
                                            }}
                                        >
                                            <img
                                                className="card-img-top"
                                                src="assets/images/small/small-11.png"
                                                alt="Card image cap"
                                            />
                                            <div className="card-body">
                                                <h4 className="card-title"><b>Voter ID Card Services</b></h4>
                                                <p className="card-text">
                                                    we understand the importance of your identity as a voter in the democratic process.
                                                    Our Voter ID Services are designed to make applying, updating, and managing your voter ID hassle-free and accessible online.
                                                </p>
                                                <br />
                                                <br />
                                                <br />
                                                <div className="d-grid">
                                                    <Link to="voterIDcardservice" type="button" class="btn btn-outline-dark">Apply</Link>
                                                </div>
                                            </div>
                                        </div>
                                    </Link>
                                </div>

                                <div className="col-md-4">
                                    <Link to="/creditcardservice">
                                        <div
                                            className="card d-block"
                                            style={{
                                                boxShadow: "0 4px 10px rgba(0, 0, 0, 0.3)", // Shadow effect
                                                backgroundColor: "#5971da", // Dark background
                                                color: "#ffffff", // Text color for contrast
                                                transition: "box-shadow 0.3s ease-in-out",
                                            }}
                                        >
                                            <img
                                                className="card-img-top"
                                                src="assets/images/small/small-8.png"
                                                alt="Card image cap"
                                            />
                                            <div className="card-body">
                                                <h4 className="card-title"><b>Income Tax Services</b></h4>
                                                <p className="card-text">
                                                    we offer comprehensive online income tax services to individuals, businesses, and organizations.
                                                    Our goal is to make tax filing, compliance, and planning stress-free, saving you time while ensuring accuracy and adherence to government regulations.
                                                </p>
                                                <br />
                                                <br />
                                                <div className="d-grid">
                                                    <Link to="/incometaxservicesservice" type="button" class="btn btn-outline-dark">Apply</Link>
                                                </div>
                                            </div>
                                        </div>
                                    </Link>
                                </div>

                                <Link to="/e-shramservice" className="d-flex justify-content-center align-items-center">
                                    <div className="col-md-4">
                                        <div
                                            className="card d-block"
                                            style={{
                                                boxShadow: "0 4px 10px rgba(0, 0, 0, 0.3)", // Shadow effect
                                                backgroundColor: "#5971da", // Dark background
                                                color: "#ffffff", // Text color for contrast
                                                transition: "box-shadow 0.3s ease-in-out",
                                            }}
                                        >
                                            <img
                                                className="card-img-top"
                                                src="assets/images/small/small-9.png"
                                                alt="Card image cap"
                                            />
                                            <div className="card-body">
                                                <h4 className="card-title"><b>E-shram Card Services</b></h4>
                                                <p className="card-text">
                                                    we are dedicated to empowering unorganized sector workers by providing seamless online assistance for E-Shram Card Services.
                                                    Designed to benefit laborers, farmers, and self-employed individuals, the E-Shram Card is a government initiative aimed at offering social security and welfare benefits..
                                                </p>
                                                <div className="d-grid">
                                                    <Link to="/e-shramservice" type="button" class="btn btn-outline-dark">Apply</Link>
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                </Link>

                            </div>
                        </div>
                    </div>
                </div>
            </section >
            <Footer />
        </>
    )
}

export default Service
